import React from 'react';
import { useCart } from '../context/CartContext';
import { products } from '../data/products';
const packMeta: Record<string, {
  label: string;
  tagline: string;
  contents: string[];
}> = {
  'pack-1': {
    label: 'Para el Maestro',
    tagline: 'La experiencia perfecta para una parrillada personal.',
    contents: ['300g Picanha premium', 'Chorizo artesanal', 'Aliño Corte Quiteño']
  },
  'pack-2': {
    label: 'Para la Pareja',
    tagline: 'Una velada perfecta alrededor de la parrilla.',
    contents: ['Tomahawk 800g', '2 Chorizos artesanales', 'Chimichurri de la casa', 'Vegetales asados']
  },
  'pack-3': {
    label: 'Para los Amigos',
    tagline: 'El pack definitivo para una reunión épica.',
    contents: ['Costillar entero', 'Picanha 600g', '6 Chorizos', 'Morcillas', 'Selección de salsas']
  }
};
export function PacksSection() {
  const {
    addToCart
  } = useCart();
  const packs = products.filter(p => p.category === 'packs');
  return <section id="packs" className="bg-pitch py-16 md:py-24 px-4 md:px-8" data-id="element-166">
      <div className="max-w-7xl mx-auto" data-id="element-167">
        <div className="text-center mb-10 md:mb-16" data-id="element-168">
          <p className="text-[9px] uppercase tracking-[0.3em] text-fire font-semibold mb-4" data-id="element-169">
            — Selecciones Exclusivas
          </p>
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-ink leading-tight" data-id="element-170">
            Nuestros <em className="text-fire not-italic italic" data-id="element-171">Packs</em>
          </h2>
        </div>

        <div className="flex flex-col md:flex-row items-stretch justify-center gap-px bg-ink/5" data-id="element-172">
          {packs.map(pack => {
          const meta = packMeta[pack.id];
          const isFeatured = pack.popular;
          return <div key={pack.id} className={`group relative flex flex-col items-center text-center overflow-hidden flex-1 bg-surface
                  ${isFeatured ? 'md:-mt-6 z-10 border-x-2 border-fire/30' : ''}`} data-id="element-173">
                {/* Top label */}
                <div className="w-full px-6 pt-8 pb-0" data-id="element-174">
                  <p className="text-[9px] uppercase tracking-[0.3em] text-muted font-medium" data-id="element-175">
                    {meta.label}
                  </p>
                  {isFeatured && <div className="mt-2 inline-block bg-fire text-white text-[9px] font-bold uppercase tracking-[0.2em] px-3 py-0.5" data-id="element-176">
                      Más Vendido
                    </div>}
                </div>

                {/* Image */}
                <div className={`relative flex items-center justify-center px-6 ${isFeatured ? 'py-8' : 'py-6'}`} data-id="element-177">
                  <div className={`relative overflow-hidden ${isFeatured ? 'w-44 h-44' : 'w-36 h-36'}`} data-id="element-178">
                    <img src={pack.image} alt={pack.name} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-179" />
                  </div>
                </div>

                {/* Divider */}
                <div className="w-8 h-px bg-fire/30 mb-4" data-id="element-180" />

                {/* Pack name */}
                <div className="px-6" data-id="element-181">
                  <h3 className={`font-heading italic text-ink mb-1.5 ${isFeatured ? 'text-2xl' : 'text-xl'}`} data-id="element-182">
                    {pack.name}
                  </h3>
                  <p className="text-fire font-heading font-bold text-lg mb-3" data-id="element-183">
                    ${pack.price.toFixed(2)}
                  </p>
                  <p className="text-muted text-xs font-light leading-relaxed max-w-[180px] mx-auto mb-5" data-id="element-184">
                    {meta.tagline}
                  </p>
                </div>

                {/* Contents */}
                <div className="px-6 mb-6 w-full" data-id="element-185">
                  <ul className="space-y-1" data-id="element-186">
                    {meta.contents.map(item => <li key={item} className="text-[11px] text-muted tracking-wide flex items-center justify-center gap-2" data-id="element-187">
                        <span className="text-fire text-[8px]" data-id="element-188">◆</span>
                        {item}
                      </li>)}
                  </ul>
                </div>

                <div className="w-full border-t border-ink/8 mt-auto" data-id="element-189" />

                <button onClick={() => addToCart(pack)} className={`w-full py-4 text-[10px] uppercase tracking-[0.2em] font-semibold transition-colors flex items-center justify-center gap-3
                    ${isFeatured ? 'bg-fire text-white hover:bg-ember' : 'text-muted hover:text-ink hover:bg-surface2'}`} data-id="element-190">
                  Agregar al Carrito
                  <span className="text-sm leading-none" data-id="element-191">→</span>
                </button>
              </div>;
        })}
        </div>
      </div>
    </section>;
}